import {
  SBL_3444_BULK_YOUTH_LEADERSHIP_POSITIONS,
  SBL_5198_CUB_BULK_ENTRY,
} from '@config/config';
import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { Program } from '@shared/constants';

export function shouldShowMeritBadgeBulkEntry(program: string) {
  if (!featureFlags.getFlag('SBL_3435_SHOW_BULK_ENTRY_MB')) return false;

  if (program === Program.CUB_SCOUT || program === Program.EXPLORING)
    return false;

  return true;
}

export function shouldShowAdventuresBulkEntry(program: string) {
  if (program === Program.EXPLORING) return false;

  if (program !== Program.CUB_SCOUT) return false;

  if (SBL_5198_CUB_BULK_ENTRY) return true;

  return true;
}

export function shouldShowAwardsBulkEntry(program: string) {
  if (!featureFlags.getFlag('SBL_4366_BULK_ENTRY_AWARDS')) return false;

  if (program) return true;
  return true;
}

export function shouldShowRankBulkEntry(program: string) {
  if (!featureFlags.getFlag('SBL_4005_SHOW_RANK_QUICK_ENTRY')) return false;

  if (program === Program.CUB_SCOUT || program === Program.EXPLORING)
    return false;

  return true;
}

export function shouldShowYouthLeadershipBulkEntry(program: string) {
  if (!SBL_3444_BULK_YOUTH_LEADERSHIP_POSITIONS) return false;
  if (program === Program.EXPLORING) return false;

  if (
    program === Program.BOY_SCOUT ||
    program === Program.SEA_SCOUT ||
    program === Program.VENTURING
  )
    return true;

  return false;
}
